import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLazyload from 'vue-lazyload'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Autocomplete from 'vuejs-auto-complete'
import VueCarousel from 'vue-carousel';
import Notifications from 'vue-notification'
require('@/plugin/importFontAwesome.js')

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

Vue.use(VueLazyload, {
  error: require('@/assets/img/image-not-found.jpg'),
  loading: require('@/assets/img/loader.gif'),
})
Vue.use(Notifications)
Vue.use(VueCarousel);

new Vue({
  router,
  store,
  components: {
    Autocomplete,
  },
  render: h => h(App)
}).$mount('#app')
